/**
 * `sessions` — accès (base plateforme, 4.1 ; sessions opaques reprises de Venio, 7.8).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
export const sessionSchema = withAudit(z.object({
    _id: idSchema,
    compteId: idSchema,
    jetonHash: z.string(),
    expireLe: z.date(),
    adresse: z.string().optional(),
    agent: z.string().optional(),
    deuxFacteursValide: z.boolean().default(false),
    revoqueeLe: z.date().optional(),
}));
export const sessionCreationSchema = sessionSchema.omit({
    ...CHAMPS_DOCUMENT,
    revoqueeLe: true,
});
export const sessionMiseAJourSchema = sessionCreationSchema
    .omit({ compteId: true, jetonHash: true })
    .partial();
//# sourceMappingURL=sessions.js.map